import ApiService, {callCustomMethodAsync}  from '../service/ApiService';

let moduleApi = {};
let moduleName = "shift";

moduleApi.create = async (dataForm) => { 
 let api = {
    module: moduleName,
    type: "create",
    value: dataForm,
    message: {
        success: "", //string | null | comment
        error: "hidden", //string | null | comment
    },
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.update = async (dataForm) => {
  let api = {
    module: moduleName,
    type: "partialUpdate",
    value: dataForm,
    message: {
        success: "", //string | null | comment
        error: "hidden", //string | null | comment
    },
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.list = async (dataFilter,loading) => {
  let api = {
    module: moduleName,
    type: "list",
    value: dataFilter,
    dontLoading: (loading == undefined ? false : loading ),
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.delete = async (id) => {
  let api = {
    module: moduleName,
    type: "delete",
    value: {id: id}
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.findById = async (id) => {
  let api = {
    module: moduleName,
    type: "findById",
    value: {id: id}
  };
  
  const result = await ApiService(api);
  mushroom[moduleName].invalidCache();
  return result;
};

moduleApi.SuggestAssignShift = (data) => {
  let api = {
      module: moduleName,
      type: "SuggestAssignShift",
      body: data,
      message: {
          success: "hidden", //string | null | comment
          error: "hidden", //string | null | comment
      },
  };
  return callCustomMethodAsync(api);
};

moduleApi.CalcStandardWork = (data) => {
  let api = {
      module: moduleName,
      type: "CalcStandardWork",
      body: data,
      message: {
          success: "hidden", //string | null | comment
          error: "hidden", //string | null | comment
      },
  };
  return callCustomMethodAsync(api);
};

moduleApi.GetWorksheetShiftOptions = (data) => {
  let api = {
      module: moduleName,
      type: "GetWorksheetShiftOptions",
      body: data,
      message: {
          success: "hidden",
          error: "hidden",
      },
  };
  return callCustomMethodAsync(api);
};

export default moduleApi;
